import { createReducer } from '@reduxjs/toolkit';
import { surveyTemplateActions } from '~/behaviors/actions/surveyTemplates.actions';
import { accountActions } from '~/behaviors/actions/account.actions';
import { metaActions } from '~/behaviors/actions/meta.actions';
import { SurveyTemplateDict } from '~/interfaces/survey_template.interface';
import { handleUnsafeOptionalChaining } from '~/tools/lint/handleUnsafeOptionalChaining';

const defaultState = {};

const reset = () => defaultState;

const replaceSurveyTemplates = (state, action) => {
  return action?.payload?.entities?.surveyTemplates || defaultState;
};

const mergeSurveyTemplate = (state, action) => {
  const surveyTemplates: SurveyTemplateDict = action?.payload?.entities?.surveyTemplates || {};
  Object.values(surveyTemplates).forEach((surveyTemplate) => {
    state[surveyTemplate.id] = surveyTemplate;
  });
};

const mergeSurveyTemplateElements = (state, action) => {
  const surveyTemplates: SurveyTemplateDict = action?.payload?.entities?.surveyTemplates || {};
  Object.values(surveyTemplates).forEach((surveyTemplate) => {
    state[surveyTemplate.id].surveyElements = surveyTemplate.surveyElements;
  });
};

const removeSurveyTemplate = (state, action) => {
  const templateId = action?.payload?.templateId;
  if (templateId) {
    delete state[templateId];
  }
};

const updateSurveyTemplateStatus = (state, action) => {
  const { templateId, newStatus, updated } = handleUnsafeOptionalChaining(action?.payload);
  if (!templateId && !newStatus) return state;

  state[templateId] = { ...state[templateId], status: newStatus, updated };
};

const cloneSurveyTemplate = (state, action) => {
  const { clonedTemplate } = handleUnsafeOptionalChaining(action?.payload);

  if (!clonedTemplate?.id) {
    return state;
  }

  state[clonedTemplate.id] = { ...clonedTemplate };
};

const surveyTemplates = createReducer(defaultState, (builder) => {
  builder
    .addCase(metaActions.reset, reset)
    .addCase(accountActions.logout.pending, reset)
    .addCase(accountActions.switchCompany.pending, reset)
    .addCase(surveyTemplateActions.fetchAllSurveyTemplates.fulfilled, replaceSurveyTemplates)
    .addCase(surveyTemplateActions.addSurveyTemplate.fulfilled, mergeSurveyTemplate)
    .addCase(surveyTemplateActions.fetchSurveyTemplate.fulfilled, mergeSurveyTemplate)
    .addCase(surveyTemplateActions.fetchSurveyTemplateElements.fulfilled, mergeSurveyTemplateElements)
    .addCase(surveyTemplateActions.updateSurveyTemplate.fulfilled, mergeSurveyTemplate)
    .addCase(surveyTemplateActions.deleteSurveyTemplate.fulfilled, removeSurveyTemplate)
    .addCase(surveyTemplateActions.updateSurveyTemplateStatus.fulfilled, updateSurveyTemplateStatus)
    .addCase(surveyTemplateActions.cloneSurveyTemplate.fulfilled, cloneSurveyTemplate);
});

export default surveyTemplates;
